import { useState } from 'react'
import { Box, Circle, Flex, Icon, Text, VStack } from '@chakra-ui/react'
import { faCheck, faCircle, faClock } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import type { PolicyVersionItem } from '@/dtos/exceptionalDiscount'
import { PolicyVersionStatus } from '@/dtos/exceptionalDiscount'
import { statusRailColor } from '../components/StatusChip'
import { VerzeCard } from './VerzeCard'

const railIcon = (status: PolicyVersionStatus) => {
  switch (status) {
    case PolicyVersionStatus.active: return faCircle
    case PolicyVersionStatus.terminated: return faCheck
    default: return faClock
  }
}

export const VerzeTimeline = ({ versions, deletablePendingId, onDeletePending }: {
  versions: PolicyVersionItem[]
  deletablePendingId?: number
  onDeletePending: () => void
}) => {
  const [expandedIds, setExpandedIds] = useState<Set<number>>(
    () => new Set(versions.filter(v => v.status === PolicyVersionStatus.active).map(v => v.policyVersionId)),
  )

  const toggle = (id: number) =>
    setExpandedIds(prev => {
      const next = new Set(prev)
      if (next.has(id)) next.delete(id)
      else next.add(id)
      return next
    })

  if (versions.length === 0) {
    return <Text color="gray.500" fontSize="sm">Žádná data k zobrazení</Text>
  }

  return (
    <VStack alignItems="stretch" spacing={0} p={4}>
      {versions.map((version, index) => (
        <Flex key={version.policyVersionId || `synthetic-${index}`} gap={4} pb={index === versions.length - 1 ? 0 : 6} position="relative">
          <Box flex="none" w={10} position="relative">
            <Box
              position="absolute"
              left="50%"
              transform="translateX(-50%)"
              w="2px"
              bg="gray.100"
              top={index === 0 ? '13px' : '-24px'}
              bottom={index === versions.length - 1 ? 'calc(100% - 13px)' : '-24px'}
            />
            <Circle
              size={7}
              bg={statusRailColor[version.status]}
              position="absolute"
              top="13px"
              left="50%"
              transform="translate(-50%, -50%)"
              boxShadow="0 0 0 3px white"
              zIndex={1}
            >
              <Icon as={FontAwesomeIcon} icon={railIcon(version.status)} color="white" boxSize={3} />
            </Circle>
          </Box>
          <VerzeCard
            version={version}
            expanded={expandedIds.has(version.policyVersionId)}
            onToggleExpand={() => toggle(version.policyVersionId)}
            showDelete={!!deletablePendingId && version.policyVersionId === deletablePendingId}
            onDelete={onDeletePending}
          />
        </Flex>
      ))}
    </VStack>
  )
}
